<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'HubExpertRessourcesRedigerProgrammeDeFormation'
});
</script>
<template>
  <ka-container
    code="expert-ressource-2-prog-de-formation"
    :data="page.$info.expertRessource2ProgDeFormation">
    <!-- Container page -->
    <ka-container code="container-page">
      <!-- Container -->
      <ka-container code="container">
        <ka-text
          code="lt-toutes-les-ressources"
          :options="{
            href: { name: `hub-expert-Ressources` },
            click: page.ltToutesLesRessourcesClick
          }"
          :xs="{ hidden: null }">
          <span v-html="t('expertRessource2ProgDeFormation.containerPage.container.ltToutesLesRessources.value', `< Toutes les ressources`)" />
        </ka-text>
        <ka-text code="comment-rediger-un">
          <h1 v-html="t('expertRessource2ProgDeFormation.containerPage.container.commentRedigerUn.value', `<strong>Comment rédiger un programme de formation ?</strong>`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-1" />
      </ka-container>
      <!-- Container -->
      <ka-container code="container-2">
        <ka-text code="creation-programme">
          <h2 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.creationProgramme.value', `La création d’un programme de formation `)" />
        </ka-text>
        <ka-text code="le-programme-de-formation">
          <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.leProgrammeDeFormation.value', `Le programme de formation divise en différentes parties l’accompagnement. <br> <br>D’après les templates délivrés par Matchers, l’expert est chargé d’adapter le contenu pour qu’il soit en accord avec les objectifs et les projets de l’entreprise. <strong>Vous pouvez ainsi re-nommer des parties, en modifier l’ordre, en ajouter de nouvelles et en supprimer certaines.</strong> <br> <br>Vous êtes libre est libre de vous approprier ce support. Le template vous est envoyé avant le lancement de la formation d'après la thématique sur laquelle vous devez intervenir. `)" />
        </ka-text>
        <ka-image
          code="image"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Création de parties, fil conducteur, ordre... avec Matchers, soyez sûrs d'avoir toutes les cartes en main pour établir un programme de formation réussi !`
          }"
          value="https://ucarecdn.com/9d9bd85d-ef1e-4ff7-afe5-949caa2b5997/" />
        <ka-text code="k-4-objectifs">
          <h2 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.k4Objectifs.value', `Les 4 objectifs du programme de formation 👌`)" />
        </ka-text>
        <!-- objectifs - déroulant -->
        <ka-container code="objectifs-deroulant">
          <!-- Conteneur question -->
          <ka-container code="conteneur-question">
            <!-- Deroulent -->
            <ka-container
              code="deroulent"
              :options="{
                click: page.deroulentClick,
                $state: { selected: $isEqual(page.$elements['question-1']?.style.hidden, page.$constants.question1Hidden) }
              }"
              :selected="{ click: page.deroulentClickWhenSelected }">
              <!-- placement -->
              <ka-container code="placement">
                <ka-text code="k-1-mettre-tout-le-monde">
                  <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.objectifsDeroulant.conteneurQuestion.deroulent.placement.k1MettreToutLeMonde.value', `1. Mettre tout le monde d’accord`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-4"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 1 -->
            <ka-container
              code="question-1"
              :options="{
                animationIn: `fadeIn`,
                style: { hidden: null },
                hidden: null
              }">
              <ka-text code="il-est-important-de">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.objectifsDeroulant.conteneurQuestion.question1.ilEstImportantDe.value', `Il est important de s’assurer que les objectifs de la formation soient clairs pour chacune des parties. Le programme de formation répertorie tous les sujets et les notions qui vont être abordés. <br> <br>Le programme est partagé avec l’entreprise et Matchers qui peuvent interagir sur le le document et le valider. Cette validation commune permet d’aligner notre vision de l’accompagnement.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-3">
            <!-- Deroulent -->
            <ka-container
              code="container-4"
              :options="{
                click: page.container4Click,
                $state: { selected: $isEqual(page.$elements['question-2']?.style.hidden, page.$constants.question2Hidden) }
              }"
              :selected="{ click: page.container4ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-5">
                <ka-text code="k-2-agir-comme-fil-conducteur">
                  <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.objectifsDeroulant.container3.container4.container5.k2AgirCommeFilConducteur.value', `2. Agir comme fil conducteur sans perdre de vue les objectifs`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-1"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 2 -->
            <ka-container
              code="question-2"
              :options="{
                style: { hidden: null },
                hidden: null
              }">
              <ka-text code="text-1">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.objectifsDeroulant.container3.question2.text1.value', `Le programme de formation est un fil rouge sur lequel vous allez vous appuyer tout au long de l’accompagnement.<strong> </strong><br> <br>La pédagogie Matchers s’appuie essentiellement sur<strong> l’application et la mise en pratique plutôt que l’apprentissage théorique. </strong>De ce fait, il se peut que les aléas d’un projet en entreprise bouleverse le rythme de la formation. Certaines parties pourront s’avérer moins pertinentes que d’autres et ainsi être abordées plus rapidement. À l'inverse, certaines thématiques peuvent prendre plus de temps. Il n’y a aucun souci avec ces changements. <br> <br>En revanche, <strong>le programme permet de recadrer</strong> l’accompagnement dans le cas où <strong>la formation s’éloignerait trop des objectifs initiaux</strong>. Il permet à l’expert comme au client de réaligner l’accompagnement sur les points listés dans le programme. <br> <br>Si les priorités de l’entreprise s’éloignent trop, au gré des semaines, du programme établi, il ne faut pas hésiter à contacter l'équipe Matchers pour ré-ajuster le tir.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-6">
            <!-- Deroulent -->
            <ka-container
              code="container-7"
              :options="{
                click: page.container7Click,
                $state: { selected: $isEqual(page.$elements['question-3']?.style.hidden, page.$constants.question3Hidden) }
              }"
              :selected="{ click: page.container7ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-8">
                <ka-text code="k-3-permettre-le-financement">
                  <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.objectifsDeroulant.container6.container7.container8.k3PermettreLeFinancement.value', `3. Permettre le financement de la formation`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-3"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 3 -->
            <ka-container
              code="question-3"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="lors-de-la-demande">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.objectifsDeroulant.container6.question3.lorsDeLaDemande.value', `Lors de la demande de financement d’une formation, le programme est un document à fournir <strong>pour débloquer le budget </strong>de l'entreprise auprès de son OPCO (opérateur de compétences). <br> <br>L’organisme financeur s’assure ainsi que le programme décrit bien les différentes étapes que les stagiaires auront à parcourir pour acquérir de nouvelles compétences.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-9">
            <!-- Deroulent -->
            <ka-container
              code="container-10"
              :options="{
                click: page.container10Click,
                $state: { selected: $isEqual(page.$elements['question-4']?.style.hidden, page.$constants.question4Hidden) }
              }"
              :selected="{ click: page.container10ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-11">
                <ka-text code="k-4-garantir-laptitude">
                  <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.objectifsDeroulant.container9.container10.container11.k4GarantirLaptitude.value', `4. Garantir l’aptitude de nos formateurs à transmettre`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-2"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 4 -->
            <ka-container
              code="question-4"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="bien-que-nous-encourageons">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.objectifsDeroulant.container9.question4.bienQueNousEncourageons.value', `Bien que nous encourageons nos experts à se baser sur des <strong>mises en application concrètes</strong> de leur savoir-faire auprès des entreprises, le programme de formation reste un document primordial pour <strong>attester de l’agilité de nos experts</strong>. <br> <br>En effet, il permet d’<strong>ordonner et rendre tangible la formation</strong>. Pour notre équipe, il est un élément d’appréciation concernant l’aptitude de nos experts à organiser leur partage de connaissances. <br> <br>Conceptualiser et organiser ses pensées est la première étape pour les transmettre. 😉`)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
        <ka-text code="structure">
          <h2 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.structure.value', `La structure du programme de formation`)" />
        </ka-text>
        <ka-text code="sous-titre">
          <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.sousTitre.value', `Des parties, des modules des chapitres ?`)" />
        </ka-text>
        <ka-text code="une-formation-peut">
          <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.uneFormationPeut.value', `<span style='background-color:transparent;color:#000000;'>Une formation peut être divisée en différents modules si elle regroupe <strong>plusieurs thématiques</strong>. Ce cas de figure nécessite souvent l’intervention de plusieurs experts.  Ces différents modules sont eux-mêmes divisés en parties qui détaillent chaque point à aborder. </span><br> <br><span style='background-color:transparent;color:#000000;'>La formation peut également être focalisée sur une seule thématique et dans ce cas le programme ne comprend qu’un module divisé en plusieurs parties.</span>`)" />
        </ka-text>
        <ka-text code="titre">
          <h2 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.titre.value', `<span style='background-color:transparent;color:#000000;'><strong>Exemple :</strong></span>`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-12">
          <!-- Container 1 -->
          <ka-container code="container-13">
            <ka-text code="plusieurs-thematiques">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.container12.container13.plusieursThematiques.value', `<strong>Plusieurs thématiques </strong><br><strong>(1 expert ou plus )</strong>`)" />
            </ka-text>
            <ka-text code="module-1">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.container12.container13.module1.value', `<p><span style='color:hsl(30, 75%, 60%);'><strong>Module 1 </strong></span></p><p> </p><p style='margin-left:40px;'><strong>Partie I </strong></p><p style='margin-left:40px;'> </p><ol><li>Sujet</li><li>Sujet</li><li>Sujet</li></ol><p> </p><p style='margin-left:40px;'><strong>Partie II</strong></p><p style='margin-left:40px;'> </p><ol><li>Sujet</li><li>Sujet</li><li>Sujet</li></ol><p> </p><p><span style='color:hsl(30, 75%, 60%);'><strong>Module 2 </strong></span></p><p style='margin-left:40px;'> </p><p style='margin-left:40px;'><strong>Partie I </strong></p><p style='margin-left:40px;'> </p><ol><li>Sujet</li><li>Sujet</li><li>Sujet</li></ol><p> </p><p style='margin-left:40px;'><strong>Partie II</strong></p><p style='margin-left:40px;'> </p><ol><li>Sujet</li><li>Sujet</li><li>Sujet</li></ol>`)" />
            </ka-text>
          </ka-container>
          <!-- Container 1 -->
          <ka-container code="container-14">
            <ka-text code="une-seule-thematique">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.container12.container14.uneSeuleThematique.value', `<strong>Une seule thématique </strong><br><strong>(1 expert)</strong>`)" />
            </ka-text>
            <ka-text code="partie-i-sujet">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.container12.container14.partieISujet.value', `<p><strong>Partie I </strong></p><p> </p><ol><li>Sujet</li><li>Sujet</li><li>Sujet</li></ol><p> </p><p><strong>Partie II</strong></p><p> </p><ol><li>Sujet</li><li>Sujet</li><li>Sujet</li></ol><p> </p><p><strong>Partie III </strong></p><p style='margin-left:40px;'> </p><ol><li>Sujet</li><li>Sujet</li><li>Sujet</li></ol><p style='margin-left:40px;'> </p>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="text-2">
          <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.text2.value', `À quel point le programme de formation doit-il être exhaustif ?`)" />
        </ka-text>
        <ka-text code="text-3">
          <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.text3.value', `Le programme de formation doit rester cohérent avec la durée de la formation. Une formation de 10h et une formation de 50h ne peuvent pas présenter le même programme de formation. Voici en exemple ce qui est acceptable.`)" />
        </ka-text>
        <ka-text code="formation-de-6-h">
          <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.formationDe6H.value', `<ul><li><span style='background-color:transparent;color:hsl(0,0%,60%);'><strong>Formation de 6h à 12h : </strong></span></li></ul><p><span style='background-color:transparent;color:hsl(0,0%,60%);'>2 parties | 3/6 points à traiter dans chaque module </span></p><p> </p><ul><li><span style='background-color:transparent;color:hsl(0,0%,60%);'><strong>Formation de 12h à 20h : </strong></span></li></ul><p><span style='background-color:transparent;color:hsl(0,0%,60%);'>2/3 parties | 4/6 points à traiter dans chaque module</span></p><p> </p><ul><li><span style='background-color:transparent;color:hsl(0,0%,60%);'><strong>Plus de 20h : </strong></span></li></ul><p><span style='background-color:transparent;color:hsl(0,0%,60%);'>1/2 modules | 2/4 parties par module | 4/6 points à traiter dans chaque </span></p><p> </p><ul><li><span style='background-color:transparent;color:hsl(0,0%,60%);'><strong>Plus de 40h : </strong></span></li></ul><p><span style='background-color:transparent;color:hsl(0,0%,60%);'>1/3 modules | 2/4 parties par module | 4/6 points à traiter dans chaque </span></p><p> </p><ul><li><span style='background-color:transparent;color:hsl(0,0%,60%);'><strong>Plus de 60h : </strong></span></li></ul><p><span style='background-color:transparent;color:hsl(0,0%,60%);'>2/3 modules | 3/4 parties par module | 4/6 points à traiter dans chaque </span></p>`)" />
        </ka-text>
        <ka-image
          code="image-1"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Évitez de passer des heures à construire un programme de formation adapté grâce aux ressources simples et claires de Matchers `
          }"
          value="https://ucarecdn.com/fee38987-b8b0-4541-b70e-665305b9a75a/" />
        <ka-text code="k-5-conseils">
          <h2 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.k5Conseils.value', `Nos 5 conseils pour établir un programme de formation Matchers 👌`)" />
        </ka-text>
        <!-- conseils - déroulant -->
        <ka-container code="conseils-deroulant">
          <!-- Conteneur question -->
          <ka-container code="container-15">
            <!-- Deroulent -->
            <ka-container
              code="container-16"
              :options="{
                click: page.container16Click,
                $state: { selected: $isEqual(page.$elements['question-5']?.style.hidden, page.$constants.question5Hidden) }
              }"
              :selected="{ click: page.container16ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-17">
                <ka-text code="k-1-sappuyer-sur-le">
                  <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container15.container16.container17.k1SappuyerSurLe.value', `1. S’appuyer sur le rendez-vous découverte`)" />
                  <template #xs>
                    <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container15.container16.container17.k1SappuyerSurLe.xs.value', `<strong>1. Se renseigner sans se lancer dans un audit approfondi</strong>`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-1"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 5 -->
            <ka-container
              code="question-5"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="si-vous-entamez-une">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container15.question5.siVousEntamezUne.value', `Si vous entamez une formation Matchers il est impératif de rencontrer l’entreprise / les apprenants au préalable. <br> <br>Votre rencontre permet de valider l'intérêt mutuel de collaborer ainsi que l’adéquation de votre expertise avec la mission proposée. <br> <p><ul><li>Si vous n’avez pas encore eu de rendez-vous découverte, nous vous laissons consulter le guide “préparer mon 1er rendez-vous découverte”. </li><li>Si vous avez eu cet échange il est important de repartir des attentes de l’entreprise. </li></ul><p> <br> <br><i>Quels objectifs l'équipe veut-elle atteindre ? Par quelles étapes doit-elle passer ?</i></p>`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-18">
            <!-- Deroulent -->
            <ka-container
              code="container-19"
              :options="{
                click: page.container19Click,
                $state: { selected: $isEqual(page.$elements['question-6']?.style.hidden, page.$constants.question6Hidden) }
              }"
              :selected="{ click: page.container19ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-20">
                <ka-text code="k-2-determiner-un-plan">
                  <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container18.container19.container20.k2DeterminerUnPlan.value', `2. Déterminer un plan d’action`)" />
                  <template #xs>
                    <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container18.container19.container20.k2DeterminerUnPlan.xs.value', `<strong>2. Prendre les choses en main : guider l’échange</strong>`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-2"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 6 -->
            <ka-container
              code="question-6"
              :options="{ hidden: null }">
              <ka-text code="il-est-tres-probable">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container18.question6.ilEstTresProbable.value', `Il est très probable que vous n’ayez jamais réalisé de programme de formation. En revanche, au cours de votre carrière vous avez très probablement déjà établi un plan d’action. Vous pouvez tout à fait vous baser sur cette pratique pour faire le programme de formation. <br> <br>Détaillez les étapes à suivre pour atteindre les objectifs de l’entreprise. Détaillez chaque point avec les notions théoriques à aborder et les mises en pratique à effectuer pour monter en compétences. <br> <br>Pour formuler au mieux vos titres vous pouvez vous appuyer sur notre guide des “do & do not”.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-21">
            <!-- Deroulent -->
            <ka-container
              code="container-22"
              :options="{
                click: page.container22Click,
                $state: { selected: $isEqual(page.$elements['question-7']?.style.hidden, page.$constants.question7Hidden) }
              }"
              :selected="{ click: page.container22ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-23">
                <ka-text code="k-3-decouper-en-plusieurs">
                  <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container21.container22.container23.k3DecouperEnPlusieurs.value', `3. Découper en plusieurs parties`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-3"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 7 -->
            <ka-container
              code="question-7"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="apres-avoir-identifie">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container21.question7.apresAvoirIdentifie.value', `Après avoir identifié tous les points à aborder vous devez les regrouper en différentes parties comme indiqué dans “la structure du programme de formation”. <br> <br>Pour une formation de 20h vous pouvez considérer qu’une partie prend environ une journée, c’est à dire 7h de formation.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-24">
            <!-- Deroulent -->
            <ka-container
              code="container-25"
              :options="{
                click: page.container25Click,
                $state: { selected: $isEqual(page.$elements['question-8']?.style.hidden, page.$constants.question8Hidden) }
              }"
              :selected="{ click: page.container25ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-26">
                <ka-text code="k-4-detailler-le-jargon">
                  <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.container25.container26.k4DetaillerLeJargon.value', `4. Détailler le “jargon”`)" />
                  <template #xs>
                    <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.container25.container26.k4DetaillerLeJargon.xs.value', `<strong>3. Prendre des notes</strong>`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-4"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 8 -->
            <ka-container
              code="question-8"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="a-chaque-metier-son">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.aChaqueMetierSon.value', `À chaque métier son langage, ses mots techniques et ses concepts clés. Il se peut que les apprenants les connaissent déjà sans pour autant en avoir saisi toutes les nuances. Affirmez vos savoirs en utilisant les termes techniques de votre expertise.<br> <br><strong>Voici quelques exemples :</strong>`)" />
              </ka-text>
              <!-- Container exemples -->
              <ka-container code="container-exemples">
                <!-- Container -->
                <ka-container code="container-27">
                  <!-- Container -->
                  <ka-container code="container-28">
                    <ka-text code="seo-referencement">
                      <h1 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container27.container28.seoReferencement.value', `SEO / Référencement`)" />
                    </ka-text>
                  </ka-container>
                  <ka-text code="agir-sur-les-3-piliers">
                    <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container27.agirSurLes3Piliers.value', `Agir sur les 3 piliers du référencement naturel : technique, éditorial et popularité.`)" />
                  </ka-text>
                </ka-container>
                <!-- Container -->
                <ka-container code="container-29">
                  <!-- Container -->
                  <ka-container code="container-30">
                    <ka-text code="custom-success">
                      <h1 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container29.container30.customSuccess.value', `Custom success`)" />
                    </ka-text>
                  </ka-container>
                  <ka-text code="etre-capable-de-visualiser">
                    <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container29.etreCapableDeVisualiser.value', `Être capable de visualiser l’expérience client (Customer Journey Mapping).`)" />
                  </ka-text>
                </ka-container>
                <!-- Container -->
                <ka-container code="container-31">
                  <!-- Container -->
                  <ka-container code="container-32">
                    <ka-text code="ressources-humaines">
                      <h1 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container31.container32.ressourcesHumaines.value', `Ressources humaines`)" />
                    </ka-text>
                  </ka-container>
                  <ka-text code="etablir-le-duer-de">
                    <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container31.etablirLeDuerDe.value', `Établir le DUER de l’entreprise (Document Unique d’Evaluation des Risques Professionnels).`)" />
                  </ka-text>
                </ka-container>
                <!-- Container -->
                <ka-container code="container-33">
                  <!-- Container -->
                  <ka-container code="container-34">
                    <ka-text code="management">
                      <h1 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container33.container34.management.value', `Management`)" />
                    </ka-text>
                  </ka-container>
                  <ka-text code="renforcer-le-sentiment">
                    <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container33.renforcerLeSentiment.value', `Renforcer le sentiment d'appartenance et d'identité commune.`)" />
                  </ka-text>
                </ka-container>
                <!-- Container -->
                <ka-container code="container-35">
                  <!-- Container -->
                  <ka-container code="container-36">
                    <ka-text code="marketing-digital">
                      <h1 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container35.container36.marketingDigital.value', `Marketing digital`)" />
                    </ka-text>
                  </ka-container>
                  <ka-text code="maitriser-la-matrice">
                    <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container35.maitriserLaMatrice.value', `Maîtriser la matrice AARRR.`)" />
                  </ka-text>
                </ka-container>
                <!-- Container -->
                <ka-container code="container-37">
                  <!-- Container -->
                  <ka-container code="container-38">
                    <ka-text code="logistique">
                      <h1 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container37.container38.logistique.value', `Logistique`)" />
                    </ka-text>
                  </ka-container>
                  <ka-text code="utiliser-la-classification">
                    <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container24.question8.containerExemples.container37.utiliserLaClassification.value', `Utiliser la classification ABC basée sur le principe de Pareto.`)" />
                  </ka-text>
                </ka-container>
              </ka-container>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-39">
            <!-- Deroulent -->
            <ka-container
              code="container-40"
              :options="{
                click: page.container40Click,
                $state: { selected: $isEqual(page.$elements['question-9']?.style.hidden, page.$constants.question9Hidden) }
              }"
              :selected="{ click: page.container40ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-41">
                <ka-text code="k-5-sinspirer-de-nos">
                  <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container39.container40.container41.k5SinspirerDeNos.value', `5. S’inspirer de nos exemples`)" />
                  <template #xs>
                    <h3 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container39.container40.container41.k5SinspirerDeNos.xs.value', `<strong>3. Prendre des notes</strong>`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-5"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 9 -->
            <ka-container
              code="question-9"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="au-meme-titre-que">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.conseilsDeroulant.container39.question9.auMemeTitreQue.value', `<span style='background-color:transparent;color:#000000;'>Au même titre que vous, d’autres experts sont déjà passés par l’étape de création de programme de formation. N’hésitez pas à consulter nos templates bien que le sujet traité soit éloigné du vôtre. </span><br> <br><span style='background-color:transparent;color:#000000;'>Vous pourrez notamment vous inspirer des tournures de phrases ou de la structure des différentes parties.</span>`)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
        <ka-text code="bonnes-et-mauvaises">
          <h2 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.bonnesEtMauvaises.value', `<strong>Les bonnes et mauvaises pratiques</strong>`)" />
        </ka-text>
        <!-- Container exemples -->
        <ka-container code="container-42">
          <!-- Container -->
          <ka-container code="container-43">
            <!-- Container -->
            <ka-container code="container-44">
              <ka-text code="utiliser-des-verbes">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.container42.container43.container44.utiliserDesVerbes.value', `<span style='background-color:transparent;color:#000000;'><strong>Utiliser des verbes d’action</strong></span><br><span style='background-color:transparent;color:#000000;'><strong>✅</strong></span>`)" />
              </ka-text>
            </ka-container>
            <ka-text code="text-4">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.container42.container43.text4.value', `<span style='background-color:transparent;color:#000000;'><i><strong>Management : </strong></i></span><br><span style='background-color:transparent;color:#000000;'>Identifier le style de communication de ses interlocuteurs.</span><br> <br><span style='background-color:transparent;color:#000000;'><i><strong>E-business : </strong></i></span><br><span style='background-color:transparent;color:#000000;'>Sélectionner la marketplace la plus adaptée à son besoin.</span><br> <br><span style='background-color:transparent;color:#000000;'><i><strong>SEO : </strong></i></span><br><span style='background-color:transparent;color:#000000;'>Intégrer la recherche de mots-clés dans la création de contenu en ligne.</span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-45">
            <!-- Container -->
            <ka-container code="container-46">
              <ka-text code="eviter-les-questions">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.container42.container45.container46.eviterLesQuestions.value', `<span style='background-color:transparent;color:#000000;'><strong>Éviter les questions comme titre </strong></span><br><span style='background-color:transparent;color:#000000;'><strong>❌</strong></span>`)" />
              </ka-text>
            </ka-container>
            <ka-text code="comment-utiliser-google">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.container42.container45.commentUtiliserGoogle.value', `<span style='background-color:transparent;color:#000000;'>Comment utiliser Google Analytics ? > </span><span style='background-color:transparent;color:#1100a2;'>Savoir utiliser Google Analytics.</span><br> <br><span style='background-color:transparent;color:#000000;'>Quelles différences entre manager et leader ? > </span><span style='background-color:transparent;color:#1100a2;'>Connaître les différences et les similitudes entre manager et leader.</span><br> <br><span style='background-color:transparent;color:#000000;'>Comment bien convertir par le biais du cold calling ? > </span><span style='background-color:transparent;color:#1100a2;'>Connaître les contraintes de l’échange téléphonique et en cultiver les atouts.</span>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="text-5">
          <h2 v-html="t('expertRessource2ProgDeFormation.containerPage.container2.text5.value', `Outils : <strong>Liste non exhaustive de verbes d’action</strong>`)" />
        </ka-text>
        <!-- Verbes d'action -->
        <ka-container
          code="verbes-daction"
          :options="{ animationIn: `fadeIn` }">
          <!-- Container exemples -->
          <ka-container code="container-47">
            <!-- Container -->
            <ka-container code="container-48">
              <!-- Container -->
              <ka-container code="container-49">
                <ka-text code="connaissance">
                  <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container48.container49.connaissance.value', `<span style='background-color:transparent;color:#000000;'><strong>Connaissance</strong></span>`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-6"
                :options="{
                  click: page.icon6Click,
                  $state: { selected: $isEqual(page.$elements['verbe-connaissance']?.style.hidden, page.$constants.verbeConnaissanceHidden) },
                  hidden: null
                }"
                value="i-fa-solid:angle-down" />
              <ka-text
                code="verbe-connaissance"
                :options="{ style: { hidden: false } }">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container48.verbeConnaissance.value', `<ul><li>Associer</li><li>Définir</li><li>Décrire</li><li>Lister</li><li>Mémoriser</li><li>Nommer</li><li>Relier</li><li>Noter</li><li>Maîtriser</li><li>Apprendre</li></ul><p> </p>`)" />
              </ka-text>
            </ka-container>
            <!-- Container -->
            <ka-container code="container-50">
              <!-- Container -->
              <ka-container code="container-51">
                <ka-text code="comprehension">
                  <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container50.container51.comprehension.value', `<span style='background-color:transparent;color:#000000;'><strong>Compréhension</strong></span>`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-7"
                :options="{ hidden: null }"
                value="i-fa-solid:angle-down" />
              <ka-text code="comprendre-classifier">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container50.comprendreClassifier.value', `<ul><li><span style='background-color:transparent;color:#000000;'>Comprendre</span></li><li><span style='background-color:transparent;color:#000000;'>Classifier </span></li><li><span style='background-color:transparent;color:#000000;'>Exprimer</span></li><li><span style='background-color:transparent;color:#000000;'>Identifier </span></li><li><span style='background-color:transparent;color:#000000;'>Traduire</span></li><li><span style='background-color:transparent;color:#000000;'>Indiquer</span></li><li><span style='background-color:transparent;color:#000000;'>Situer </span></li><li><span style='background-color:transparent;color:#000000;'>Reconnaître </span></li><li><span style='background-color:transparent;color:#000000;'>Rapporter </span></li><li><span style='background-color:transparent;color:#000000;'>Reformuler </span></li><li><span style='background-color:transparent;color:#000000;'>Défendre</span></li></ul>`)" />
              </ka-text>
            </ka-container>
            <!-- Container -->
            <ka-container code="container-52">
              <!-- Container -->
              <ka-container code="container-53">
                <ka-text code="application">
                  <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container52.container53.application.value', `<span style='background-color:transparent;color:#000000;'><strong>Application</strong></span>`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-8"
                :options="{ hidden: null }"
                value="i-fa-solid:angle-down" />
              <ka-text code="cartographier">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container52.cartographier.value', `<ul><li><span style='background-color:transparent;color:#000000;'>Cartographier</span></li><li><span style='background-color:transparent;color:#000000;'>Schématiser </span></li><li><span style='background-color:transparent;color:#000000;'>Choisir </span></li><li><span style='background-color:transparent;color:#000000;'>Démontrer </span></li><li><span style='background-color:transparent;color:#000000;'>Employer </span></li><li><span style='background-color:transparent;color:#000000;'>Illustrer </span></li><li><span style='background-color:transparent;color:#000000;'>Pratiquer </span></li><li><span style='background-color:transparent;color:#000000;'>Utiliser </span></li><li><span style='background-color:transparent;color:#000000;'>Mobiliser</span></li><li><span style='background-color:transparent;color:#000000;'>Décliner</span></li><li><span style='background-color:transparent;color:#000000;'>Réaliser</span></li><li><span style='background-color:transparent;color:#000000;'>Améliorer</span></li></ul>`)" />
              </ka-text>
            </ka-container>
            <!-- Container -->
            <ka-container code="container-54">
              <!-- Container -->
              <ka-container code="container-55">
                <ka-text code="analyse">
                  <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container54.container55.analyse.value', `<span style='background-color:transparent;color:#000000;'><strong>Analyse</strong></span>`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-9"
                :options="{ hidden: null }"
                value="i-fa-solid:angle-down" />
              <ka-text code="analyser-estimer">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container54.analyserEstimer.value', `<ul><li><span style='background-color:transparent;color:#000000;'>Analyser </span></li><li><span style='background-color:transparent;color:#000000;'>Estimer </span></li><li><span style='background-color:transparent;color:#000000;'>Calculer </span></li><li><span style='background-color:transparent;color:#000000;'>Catégoriser </span></li><li><span style='background-color:transparent;color:#000000;'>Comparer </span></li><li><span style='background-color:transparent;color:#000000;'>Contraster </span></li><li><span style='background-color:transparent;color:#000000;'>Critiquer Différencier </span></li><li><span style='background-color:transparent;color:#000000;'>Discriminer </span></li><li><span style='background-color:transparent;color:#000000;'>Distinguer </span></li><li><span style='background-color:transparent;color:#000000;'>Examiner </span></li><li><span style='background-color:transparent;color:#000000;'>Expérimenter</span></li><li><span style='background-color:transparent;color:#000000;'>Rechercher</span></li></ul>`)" />
              </ka-text>
            </ka-container>
            <!-- Container -->
            <ka-container code="container-56">
              <!-- Container -->
              <ka-container code="container-57">
                <ka-text code="synthese">
                  <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container56.container57.synthese.value', `<span style='background-color:transparent;color:#000000;'><strong>Synthèse</strong></span>`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-10"
                :options="{ hidden: null }"
                value="i-fa-solid:angle-down" />
              <ka-text code="arranger-assembler">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container56.arrangerAssembler.value', `<ul><li><span style='background-color:transparent;color:#000000;'>Arranger </span></li><li><span style='background-color:transparent;color:#000000;'>Assembler </span></li><li><span style='background-color:transparent;color:#000000;'>Collecter </span></li><li><span style='background-color:transparent;color:#000000;'>Composer </span></li><li><span style='background-color:transparent;color:#000000;'>Construire </span></li><li><span style='background-color:transparent;color:#000000;'>Créer</span></li><li><span style='background-color:transparent;color:#000000;'>Développer </span></li><li><span style='background-color:transparent;color:#000000;'>Gérer </span></li><li><span style='background-color:transparent;color:#000000;'>Organiser </span></li><li><span style='background-color:transparent;color:#000000;'>Planifier </span></li><li><span style='background-color:transparent;color:#000000;'>Préparer </span></li><li><span style='background-color:transparent;color:#000000;'>Concevoir </span></li><li><span style='background-color:transparent;color:#000000;'>Exploiter</span></li></ul>`)" />
              </ka-text>
            </ka-container>
            <!-- Container -->
            <ka-container code="container-58">
              <!-- Container -->
              <ka-container code="container-59">
                <ka-text code="evaluation">
                  <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container58.container59.evaluation.value', `<span style='background-color:transparent;color:#000000;'><strong>Évaluation</strong></span>`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-11"
                :options="{ hidden: null }"
                value="i-fa-solid:angle-down" />
              <ka-text code="argumenter-evaluer">
                <span v-html="t('expertRessource2ProgDeFormation.containerPage.container2.verbesDaction.container47.container58.argumenterEvaluer.value', `<ul><li><span style='background-color:transparent;color:#000000;'>Argumenter </span></li><li><span style='background-color:transparent;color:#000000;'>Évaluer </span></li><li><span style='background-color:transparent;color:#000000;'>Rattacher </span></li><li><span style='background-color:transparent;color:#000000;'>Choisir </span></li><li><span style='background-color:transparent;color:#000000;'>Comparer </span></li><li><span style='background-color:transparent;color:#000000;'>Estimer</span></li><li><span style='background-color:transparent;color:#000000;'>Déduire</span></li><li><span style='background-color:transparent;color:#000000;'>Chiffrer </span></li><li><span style='background-color:transparent;color:#000000;'>Distinguer </span></li><li><span style='background-color:transparent;color:#000000;'>Recommander </span></li><li><span style='background-color:transparent;color:#000000;'>Justifier </span></li><li><span style='background-color:transparent;color:#000000;'>Piloter</span></li></ul>`)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Container -->
      <ka-container code="container-60">
        <!-- Container -->
        <ka-container
          code="container-61"
          :xs="{ hidden: null }">
          <ka-text code="text-6">
            <span v-html="t('expertRessource2ProgDeFormation.containerPage.container60.container61.text6.value', `Sommaire :`)" />
          </ka-text>
          <ka-text
            code="text-7"
            :options="{
              href: { hash: `#creation-programme--p45` },
              ariaLabel: `text`,
              click: page.text7Click
            }">
            <span v-html="t('expertRessource2ProgDeFormation.containerPage.container60.container61.text7.value', `<ul><li><strong>La création d’un programme de formation</strong></li></ul>`)" />
          </ka-text>
          <!-- Container -->
          <ka-container code="container-62">
            <ka-text
              code="text-8"
              :options="{
                href: { hash: `#k-4-objectifs--p45` },
                ariaLabel: `text`,
                click: page.text8Click
              }">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container60.container61.container62.text8.value', `<ul><li><strong>Les 4 objectifs du programme </strong></li></ul>`)" />
            </ka-text>
            <ka-icon
              code="icone-dev-up"
              :options="{
                click: page.iconeDevUpClick,
                $state: { selected: $isEqual(page.$elements['k-4-objectifs-txt']?.style.hidden, page.$constants.k4ObjectifsTxtHidden) }
              }"
              :selected="{ click: page.iconeDevUpClickWhenSelected }"
              value="i-fa-solid:angle-down" />
            <ka-text
              code="k-4-objectifs-txt"
              :options="{ hidden: null }">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container60.container61.container62.k4ObjectifsTxt.value', `<span style='color:hsl(0,0%,60%);'>1 - Mettre tout le monde d'accord</span><br><span style='color:hsl(0,0%,60%);'>2 - Agir comme fil conducteur sans perdre de vue les objectifs</span><br><span style='color:hsl(0,0%,60%);'>3 - Permettre le financement de la formation</span><br><span style='color:hsl(0,0%,60%);'>4 - Garantir l'aptitude de nos formateurs à transmettre</span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-63">
            <ka-text
              code="text-9"
              :options="{
                href: { hash: `#structure--p45` },
                ariaLabel: `text`,
                click: page.text9Click
              }">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container60.container61.container63.text9.value', `<ul><li><strong>La structure d'un programme</strong></li></ul>`)" />
            </ka-text>
            <ka-icon
              code="icon-12"
              :options="{
                click: page.icon12Click,
                $state: { selected: $isEqual(page.$elements['k-4-etapes-txt']?.style.hidden, page.$constants.k4EtapesTxtHidden) }
              }"
              :selected="{ click: page.icon12ClickWhenSelected }"
              value="i-fa-solid:angle-down" />
            <ka-text
              code="k-4-etapes-txt"
              :options="{ hidden: null }">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container60.container61.container63.k4EtapesTxt.value', `<ol><li><span style='color:hsl(0,0%,60%);'>Des parties, des modules des chapitres ?</span></li><li><span style='color:hsl(0,0%,60%);'>À quel point le programme de formation doit-il être exhaustif ?</span></li></ol>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-64">
            <ka-text
              code="text-10"
              :options="{
                href: { hash: `#k-5-conseils--p45` },
                ariaLabel: `text`,
                click: page.text10Click
              }">
              <span v-html="t('expertRessource2ProgDeFormation.containerPage.container60.container61.container64.text10.value', `<ul><li><strong>Nos 5 conseils pour le construire 👌</strong></li></ul>`)" />
            </ka-text>
            <ka-icon
              code="icon-13"
              :options="{
                click: page.icon13Click,
                $state: { selected: $isEqual(page.$elements['k-6-conseils-txt']?.style.hidden, page.$constants.k6ConseilsTxtHidden) }
              }"
              :selected="{ click: page.icon13ClickWhenSelected }"
              value="i-fa-solid:angle-down" />
          </ka-container>
          <ka-text
            code="k-6-conseils-txt"
            :options="{ hidden: null }">
            <span v-html="t('expertRessource2ProgDeFormation.containerPage.container60.container61.k6ConseilsTxt.value', `<span style='color:hsl(0,0%,60%);'>1 - Se renseigner sans se lancer dans un audit </span><span style='color:hsl(0, 0%, 60%);'>approfondi</span><span style='color:hsl(0,0%,60%);'>.</span><br><span style='color:hsl(0,0%,60%);'>2 - Prendre les choses en main : guider l’échange.</span><br><span style='color:hsl(0,0%,60%);'>3 -Prendre des notes.</span><br><span style='color:hsl(0,0%,60%);'>4 - Questionner et re-questionner le projet et les attentes de l'entreprise.</span><br><span style='color:hsl(0,0%,60%);'>autour de votre collaboration.</span><br><span style='color:hsl(0,0%,60%);'>5 - Le mot de la fin : conclure le rendez-vous découverte.</span><br><span style='color:hsl(0,0%,60%);'>6 - Tenez Matchers informé !</span>`)" />
          </ka-text>
          <ka-text
            code="text-11"
            :options="{
              href: { hash: `#creation-programme--p45` },
              ariaLabel: `text`,
              click: page.text11Click
            }">
            <span v-html="t('expertRessource2ProgDeFormation.containerPage.container60.container61.text11.value', `<ul><li><strong>Les bonnes et mauvaises pratiques</strong></li></ul>`)" />
          </ka-text>
        </ka-container>
        <!-- Container 2 -->
        <ka-container code="container-65">
          <ka-text code="text-12">
            <span v-html="t('expertRessource2ProgDeFormation.containerPage.container60.container65.text12.value', `Autres ressources disponibles :`)" />
          </ka-text>
          <BlocPreviewRessourceSansDescription
            instance-class="bloc-preview-ressource-sans-description--p45"
            :options="{
              href: { name: `hub-expert-Ressources-preparer-rdv-decouverte` },
              click: page.blocPreviewRessourceSansDescriptionClick
            }" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-1--p45"
            :options="{
              href: { name: `hub-expert-Ressources-construire-support-de-formation` },
              click: page.element1Click
            }"
            title="<strong>Comment créer mon support de formation ?</strong>"
            image="https://ucarecdn.com/a2a44513-0560-4647-bf8d-08185038c949/" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-2--p45"
            :options="{
              href: { name: `Expert-Ressources-organiser-sa-formation` },
              click: page.element2Click
            }"
            title="<strong>Comment bien organiser sa formation ?</strong>"
            image="https://images.unsplash.com/photo-1616530834117-9167fb0d8ebc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxOXx8Y2FsZW5kYXJ8ZW58MHx8fHwxNjkyODAwMTMzfDA&ixlib=rb-4.0.3&q=80&w=1080" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-3--p45"
            :options="{
              href: { name: `Expert-Ressources-animer-la-formation` },
              click: page.element3Click
            }"
            title="<strong>Animer la formation</strong>"
            image="https://images.unsplash.com/photo-1612831455359-970e23a1e4e9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHw5fHxwciVDMyVBOXNlbnRhdGlvbnxlbnwwfHx8fDE2OTIyNjA3OTJ8MA&ixlib=rb-4.0.3&q=80&w=1080" />
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { hubExpertRessourcesRedigerProgrammeDeFormation } from './store'
import BlocPreviewRessourceSansDescription from '~/components/BlocPreviewRessourceSansDescription/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p45')
const appData = appDataStore()
const page = hubExpertRessourcesRedigerProgrammeDeFormation()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
